import { FetchWithAuth } from "./apiService";

export async function getSellers(auth) {
	return FetchWithAuth(auth, "sellers");
}
export async function getSellerById(auth, id) {
	return FetchWithAuth(auth, "sellers/" + id);
}
export async function updateSeller(auth, id, name) {
	return FetchWithAuth(auth, "sellers/" + id, { name }, { method: "PUT" });
}
export async function deleteSeller(auth, id) {
	return FetchWithAuth(auth, "sellers/" + id, null, { method: "DELETE" });
}
export async function createSeller(auth, short_name, name) {
	return FetchWithAuth(auth, "sellers", { short_name, name }, { method: "POST" });
}
